import React from 'react';
import { IconButton, IconMoveEndLine } from '@instructure/ui';
import {
  usePlayerStore,
  useExamSessionStore,
  getStore,
} from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';
const LiveButton = () => {
  const PlayerStore = getStore('playerStore');

  {
    /* Listen to any changes in the stores... */
  }
  const isLive = usePlayerStore((state) => state.isLive);
  const canHaveLiveVideo = usePlayerStore(
    (state) => state.canHaveLiveVideo
  );

  return (
    <>
      {!isLive && canHaveLiveVideo && (
        <IconButton
          as="span"
          size="small"
          margin="none none none x-small"
          screenReaderLabel="Pause Playback"
          onClick={() => {
            PlayerStore.setActiveVideoSource(CONSTANTS.VIDEO_SOURCES.LIVE);
          }}
        >
          <IconMoveEndLine size="x-small" />
        </IconButton>
      )}
    </>
  );
};

export default LiveButton;
